// extracted by mini-css-extract-plugin
export var fadeInAnimation = "OwnerInfo-module--fadeInAnimation--24e6d";
export var figcaption = "OwnerInfo-module--figcaption--b348c";
export var figure = "OwnerInfo-module--figure--3da65";
export var figureImage = "OwnerInfo-module--figureImage--6861f";
export var name = "OwnerInfo-module--name--09a84";
export var position = "OwnerInfo-module--position--e59a7";